import { makeStyles } from "@mui/styles"

const useStyles = makeStyles((theme) => ({
  container: {
    minHeight: "calc(100vh - 115px)",
    [theme.breakpoints.up("xxl")]: {
      minHeight: "calc(100vh - 125px)",
    },
  },
}))

export default useStyles
